export default __webpack_public_path__ + "static/media/logo_tmb.74fe1764.png";